
import { Container, TextStyle, Text, Graphics, Sprite } from 'pixi.js'
//import { Easing, Tween, autoPlay } from '../GameEngine/es6-tween.js'
import TWEEN from '@tweenjs/tween.js' ;
export default class TurnTimer extends Sprite {
    constructor(color,...arg) {
        super(...arg);
        this.color = color||0xFFFFFF;
        //this.duration = duration||20;

        //create rectangle 
    
        this.rectangle = new Graphics();
        this.rectangle.beginFill(this.color );
        //this.rectangle.lineStyle(4, this.color, 1);
        this.rectangle.drawRect(0,0,100,6);
        this.addChild(this.rectangle);

        this.rectangle.width=0;
        //this.hide();
      

        this.tweenGroup = new TWEEN.Group();

        this.tween = new TWEEN.Tween(this.rectangle, this.tweenGroup);
        this.tween.to({ width: 100 }, 10000);
        this.tween.onStart(this.onStart.bind(this));
        this.tween.onComplete(this.onComplete.bind(this));
        this.tween.onStop(this.onStop.bind(this));
        //.start();

        //this.show("Test Test Test Test Test Test");
    }
    update(instantMove) {
        let isDirty = false;


        let isPlaying = this.tween.isPlaying();
        if (isPlaying) {
            let updated = this.tweenGroup.update();
            isDirty = true;
        }

        return isDirty;

    }
    onStart() {
        this.visible = true;
    }
    onComplete() {
        this.visible = false;
        this.rectangle.width = 0;
    }
    onStop() {
        this.visible = false;
    }
    show(duration) {
        //reset pos 
        this.visible = true;
        this.rectangle.width = 0;
        this.tween.to({ width: 100 }, duration);
        this.tween.start();
    }
    hide() {
        this.visible = false;
    }
}